export default __webpack_public_path__ + "static/media/discover.eff6d16a.svg";